export default __webpack_public_path__ + "suitcase-with-white-details.png";